import { styled } from 'core'

export const MoonLoaderWrapper = styled('div')`
    position: fixed;
    z-index: 999;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    display: flex;
    align-items: center;
    justify-content: center;
`
